import './ContractConfirmModal.scss'

import React from 'react'
import { connect } from 'react-redux'
import { connectModal } from 'redux-modal'
import { Button, Modal } from 'react-bootstrap'
import accounting from 'accounting'

const ContractConfirm = ({
  handleHide,
  handleSave,
  show,
  is_lease,
  contract_mls,
  contract_property_address,
  contract_amount,
  contract_close_date,
}) => {
  const onSubmit = _.debounce(()=>{
    handleSave()
    handleHide()
  } , 500, {leading: true, trailing: false})

  const amountLabel = is_lease ? <span>Lease Amount</span> : <span>Contract Amount</span>
  const dateLabel = is_lease ? <span>Lease Move-In Date</span> : <span>Contract Close Date</span>

  return (
    <Modal className="ContractConfirmModal" show={show}>
      <Modal.Body>
        <div className="ContractConfirmModal__title">
          <span className="fa fa-check-circle"></span> Confirm Contract Details
        </div>

        {!!contract_mls && (
          <div className="ContractConfirmModal__input-wrapper">
            <div className="ContractConfirmModal__input-label">MLS Number</div>
            <div className="ContractConfirmModal__input">{contract_mls}</div>
          </div>
        )}

        {!!contract_property_address && (
          <div className="ContractConfirmModal__input-wrapper">
            <div className="ContractConfirmModal__input-label">Property Address</div>
            <div className="ContractConfirmModal__input">{contract_property_address}</div>
          </div>
        )}

        {!!contract_amount && (
          <div className="ContractConfirmModal__input-wrapper">
            <div className="ContractConfirmModal__input-label">{ amountLabel }</div>
            <div className="ContractConfirmModal__input">
              {accounting.formatMoney(contract_amount, {precision: 0})} { is_lease ? <span>/ month</span> : null }
            </div>
          </div>
        )}

        {!!contract_close_date && (
          <div className="ContractConfirmModal__input-wrapper">
            <div className="ContractConfirmModal__input-label">{ dateLabel }</div>
            <div className="ContractConfirmModal__input">{contract_close_date}</div>
          </div>
        )}

        <Button onClick={onSubmit} bsStyle="primary">Confirm</Button>
        <Button onClick={handleHide} bsStyle="default">I need to make a change</Button>
      </Modal.Body>
    </Modal>
  )
}

const selector = state => {
  const is_lease = _.get(state, ['referral', 'referral', 'is_lease'])

  const last_contract_mls = _.get(state, ['referral', 'referral', 'agent_contract_mls'])
  const last_property_address = _.get(state, ['referral', 'referral', 'agent_contract_property_address'])
  const last_contract_amount = _.get(state, ['referral', 'referral', 'agent_contract_amount'])
  const last_close_date = _.get(state, ['referral', 'referral', 'agent_contract_close_date'])

  const contract_mls = _.get(state, ['referralStatus', 'contract_mls'], last_contract_mls)
  const contract_property_address = _.get(state, ['referralStatus', 'contract_property_address'], last_property_address)
  const contract_amount = _.get(state, ['referralStatus', 'contract_amount'], last_contract_amount)
  const contract_close_date = _.get(state, ['referralStatus', 'contract_close_date'], last_close_date)

  return {
    is_lease,
    contract_mls,
    contract_property_address,
    contract_amount,
    contract_close_date,
  }
}

const withModalHandlers = connectModal({ name: 'ContractConfirmModal', destroyOnHide: true })

const withRedux = connect(selector, {})

export const ContractConfirmModal = withModalHandlers(withRedux(ContractConfirm))
